import { render, staticRenderFns } from "./ModalWaiting.vue?vue&type=template&id=518f4b12&scoped=true&"
import script from "./ModalWaiting.vue?vue&type=script&lang=js&"
export * from "./ModalWaiting.vue?vue&type=script&lang=js&"
import style0 from "./ModalWaiting.vue?vue&type=style&index=0&id=518f4b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f4b12",
  null
  
)

export default component.exports